<template>
  <b-popover :show.sync="showPopover"
             custom-class="llp-increments-popover"
             :target="target"
             triggers="click"
             placement="lefttop">
    <template v-slot:title>
      <div class="d-flex">
        {{ $t('Increments for Lot') }}
      </div>
    </template>
    <div class="p-2">
      <increment-tiers :model="model" attribute="increments"/>
    </div>
    <div class="d-flex justify-content-end bg-light p-2">
      <b-button size="sm" variant="danger" class="mr-2" @click="onCancelClick">
        <font-awesome-icon icon="times"/>
        {{ $t('Cancel') }}
      </b-button>
      <b-button size="sm" variant="primary" @click="onOkClick">
        <font-awesome-icon icon="save"/>
        {{ $t('Save') }}
      </b-button>
    </div>
  </b-popover>
</template>

<script>
import IncrementTiers from "../../core/components/increment-tiers/IncrementTiers";
import IncrementsModel from "../sales/view/terms/modals/IncrementsModel.model";
import Increment from "../../core/components/increment-tiers/Increment.model";

export default {
  name: "IncrementsPopover",
  components: {IncrementTiers},
  props: {
    increments: {
      type: Array,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    target: String
  },
  data: () => ({
    showPopover: false,
    model: new IncrementsModel()
  }),
  watch: {
    show: {
      immediate: true,
      handler() {
        this.showPopover = this.show
      }
    },
    increments: {
      immediate: true,
      handler(){
        this.model = new IncrementsModel({increments: this.increments.map(data => new Increment(data))})
      }
    }
  },
  methods: {
    onCancelClick() {
      this.showPopover = false;
      this.model = new IncrementsModel({increments: this.increments.map(data => new Increment(data))});
      this.$emit('cancel')
    },
    onOkClick() {
      this.showPopover = false;
      let increments = this.model.increments.map(increment => increment.toJSON());

      this.$emit('ok', increments)
    }
  }
}
</script>

<style scoped>

</style>
